<template>
  <div class="paas-split">
    <Split v-model="split" :min="siderWidth" v-height="{offsetHeight:100}">
      <div slot="left" class="paas-split-pane"  ref="treeWrap">
        <wrapper-tree
          title="图片分类"
          ref="wrapperTree"
          icon = "iconfont iconnavicon-lcpz"
          offsetHeight = 70
          :serviceUrl="serviceUrl"
          :currentIdFiledName="currentIdFiledName"
          :start-tree-node="startTreeCode"
          tree-node-icon="iconfont iconpaixing"
          treeType="query"
          @on-node-click="paasNodeClick">
        </wrapper-tree>
      </div>
      <router-view :key="key" slot="right" class="paas-split-pane">
      </router-view>
    </Split>
  </div>
</template>

<script>
  import wrapperTree from '@/components/paas/wrapper-tree'
  export default {
    name: "frame",
    components:{wrapperTree},
    data(){
      return{
        serviceUrl:"/sys/image/category", //后台访问路径，必须
        currentIdFiledName:"sysImageCategoryId",
        siderWidth:"250px",  //sider的宽度，必须是String类型的
        treeHeight:'', //树的高度
        startTreeCode:'',  //起始树节点,只传paasLikeTreeCode的值 '100'、'101'等等
        key:'' ,//route-view更新
        split:0.25  //面板位置，可以是 0~1 代表百分比，或具体数值的像素，可用 v-model 双向绑定
      }
    },
    methods:{
      paasNodeClick(node){
        this.$bus.emit("query-list",node);
      },

    }
  }
</script>

<style scoped>
  .paas-split{
    padding:10px;
  }
  .paas-split >>> .wrapper{
    padding:0px;
  }
  .paas-split-pane,.paas-split >>> .paas-split-pane{
    padding-left:5px;
  }
</style>
